import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class ImportTypeService extends RestfulService<Models.ImportType> {

  constructor(private restService: RestService) {
    super(Models.ImportType);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('import-types');
  }

}
